import loadable from '@loadable/component';

export const EditOrgLinksLoadable = loadable(() => import('./EditOrgLinks'), {
  resolveComponent: (module) => module.EditOrgLinks,
});
